/**
 * An object representing the supported languages for translations.
 * @constant
 */
export const TranslationsLanguages = {
  IT: 'it',
  EN: 'en',
}

/**
 * An object representing the supported platform for translations.
 * @constant
 */
export const TranslationsPlatform = {
  WEB: 'web',
  APP: 'app',
}
